import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  inject,
} from '@angular/core';

import { RecaptchaModule } from 'ng-recaptcha';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Environment, ENVIRONMENT } from '@web/config';
import { isNotNil, Nillable } from '@web/utils';

@Component({
  selector: 'app-re-captcha',
  imports: [RecaptchaModule],
  templateUrl: './re-captcha.component.html',
  styleUrl: './re-captcha.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReCaptchaComponent),
      multi: true,
    },
  ],
})
export class ReCaptchaComponent implements ControlValueAccessor {
  private readonly environment = inject<Environment>(ENVIRONMENT);

  private onChange!: (value: boolean) => void;
  private onTouched!: () => void;

  private isTouched = false;

  public writeValue(value: boolean): void {
    // Uniemożliwiam ustawienie wartości w kontrolce
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public handleReCaptchaResolved(verificationKey: Nillable<string>): void {
    this.markAsTouched();
    this.onChange(isNotNil(verificationKey));
  }

  public handleReCaptchaFailure(): void {
    this.markAsTouched();
    this.onChange(false);
  }

  protected reCaptchaSiteKey(): string {
    return this.environment.GoogleReCaptchaSiteKey;
  }

  private markAsTouched(): void {
    if (this.isTouched) {
      return;
    }

    this.isTouched = true;

    this.onTouched();
  }
}
